import { render, staticRenderFns } from "./AdminMenu.vue?vue&type=template&id=1c314f84&"
import script from "./AdminMenu.vue?vue&type=script&lang=ts&"
export * from "./AdminMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AdminMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports